module.exports = __webpack_public_path__ + "static/media/MG.23660294.svg";